/*
 * Decadence Mansion – Gift With Set Logic
 * Condition: If customer buys 1 item from Collection A and 1 from Collection B → add Gift (variant id)
 * Automatically removes gift if condition breaks.
 */

(async () => {
  const controller = document.getElementById('gift-with-set-controller');
  if (!controller) return;

  const PUBLIC_TOKEN = controller.dataset.publicToken;
  const COLLECTION_A = controller.dataset.collectionA;
  const COLLECTION_B = controller.dataset.collectionB;
  const GIFT_VARIANT = controller.dataset.giftVariantId;
  const AUTO_REMOVE = controller.dataset.autoRemove === 'true';

  // Helper: Shopify AJAX
  async function fetchJSON(url, options = {}) {
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      ...options,
    });
    return res.json();
  }

  async function getCart() {
    return fetchJSON('/cart.js');
  }

  async function addToCart(variantId, qty = 1) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ id: variantId, quantity: qty }),
    });
  }

  async function updateCart(updates) {
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ updates }),
    });
  }

  // Storefront GraphQL query to get cart product collections
  async function isQualified() {
    const cart = await getCart();
    const productIds = cart.items.map(i => i.product_id);

    const query = `
      query getProducts($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            collections(first: 10) {
              edges { node { handle } }
            }
          }
        }
      }
    `;

    const variables = {
      ids: productIds.map(id => `gid://shopify/Product/${id}`)
    };

    const res = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': PUBLIC_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });
    const json = await res.json();

    const collections = json.data.nodes.flatMap(n =>
      n?.collections?.edges?.map(e => e.node.handle) || []
    );

    const hasA = collections.includes(COLLECTION_A);
    const hasB = collections.includes(COLLECTION_B);
    return hasA && hasB;
  }

  async function hasGiftInCart() {
    const cart = await getCart();
    return cart.items.some(i => String(i.variant_id) === String(GIFT_VARIANT));
  }

  async function syncGift() {
    const qualifies = await isQualified();
    const hasGift = await hasGiftInCart();

    if (qualifies && !hasGift) {
      console.log('Adding gift to cart');
      await addToCart(GIFT_VARIANT, 1);
    } else if (!qualifies && hasGift && AUTO_REMOVE) {
      console.log('Removing gift from cart');
      await updateCart({ [GIFT_VARIANT]: 0 });
    }
  }

  // Run when cart updates
  document.addEventListener('DOMContentLoaded', syncGift);
  document.addEventListener('cart:updated', syncGift);

  // Fallback polling (some themes don’t emit events)
  let lastCartJSON = '';
  setInterval(async () => {
    const cart = await getCart();
    const serialized = JSON.stringify(cart.items.map(i => i.key));
    if (serialized !== lastCartJSON) {
      lastCartJSON = serialized;
      await syncGift();
    }
  }, 5000);
})();
